import { Compartment } from '@codemirror/state';
import { EditorView, keymap } from '@codemirror/view';
import { type MutableRefObject } from 'react';

/**
 * Configures the format keymap functionality on the editor.
 * @param handleFormat - format function
 * @param viewRef - Ref object for the editor
 * @param formatKeymapCompartment - CodeMirror Compartment that holds the keymap extension, allowing it
 *   to be swapped in at runtime once a format function is available (initialized empty, then
 *   reconfigured here via dispatch).
 */
export const configureFormatKeymap = (
  handleFormat: () => void,
  viewRef: MutableRefObject<EditorView>,
  formatKeymapCompartment: Compartment,
): void => {
  const editorView = viewRef.current;
  editorView.dispatch({
    effects: formatKeymapCompartment.reconfigure(
      keymap.of([
        {
          key: 'Ctrl-Shift-f',
          mac: 'Cmd-Shift-f',
          run: () => {
            handleFormat();
            return true;
          },
        },
      ]),
    ),
  });
};
